var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthiopia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_7814)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_7814",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_7814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 3H1V23H35.2819V3Z",
    fill: "#D03733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 3H1V16.3311H35.2819V3Z",
    fill: "#F2DD31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 3H1V9.6689H35.2819V3Z",
    fill: "#2E6D42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1426 12.9967C23.1426 15.7553 20.9063 17.9983 18.141 17.9983C15.3823 17.9983 13.1393 15.762 13.1393 12.9967C13.1393 10.238 15.3756 7.99498 18.141 7.99498C20.8996 7.99498 23.1426 10.238 23.1426 12.9967Z",
    fill: "#4DA2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3378 11.7445H17.2437L17.8999 9.72245L18.074 10.2648L17.1165 13.2042L16.8353 12.9966L17.1299 12.0793H14.7931L14.3378 11.7445ZM15.7908 16.2173L16.688 13.4519L14.9672 12.1999H15.5363L18.0338 14.0144L17.7526 14.222L16.9759 13.6528L16.2528 15.8758L15.7908 16.2173ZM20.4911 16.2173L18.1409 14.5099L16.4202 15.762L16.5942 15.2196L19.0917 13.4051L19.1989 13.7399L18.4222 14.309L20.317 15.6816L20.4911 16.2173ZM21.9441 11.7445L19.5939 13.4519L20.2501 15.474L19.7881 15.1393L18.8306 12.1999H19.1788L19.4734 13.1172L21.3683 11.7445H21.9441ZM18.1409 8.97923L19.0382 11.7445H21.1674L20.7054 12.0793H17.612L17.7191 11.7445H18.6833L17.9602 9.52158L18.1409 8.97923Z",
    fill: "#F2DD31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.228 16.994H18.0606V14.8246H18.228V16.994ZM21.9173 14.309L19.855 13.6394L19.9086 13.4787L21.9709 14.1483L21.9173 14.309ZM14.3646 14.309L14.311 14.1483L16.3733 13.4787L16.4268 13.6394L14.3646 14.309ZM19.2859 11.5638L19.152 11.4633L20.4242 9.70906L20.5581 9.8095L19.2859 11.5638ZM16.996 11.5638L15.7238 9.8095L15.8577 9.70906L17.1299 11.4633L16.996 11.5638Z",
    fill: "#F2DD31"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_7814",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_7814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_7814",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiopia);
export default __webpack_public_path__ + "static/media/Ethiopia.7fcd516a7a548eccd2215959a83f3fd4.svg";
export { ForwardRef as ReactComponent };